module.exports = __webpack_public_path__ + "static/media/hospital-week-3.ac7d5434.jpg";